import { render, staticRenderFns } from "./SelectQuestion.vue?vue&type=template&id=281ea836"
import script from "./SelectQuestion.vue?vue&type=script&lang=ts"
export * from "./SelectQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports